import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dmb-inline-spinner',
  template: '<div></div>',
  styleUrl: './inline-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineSpinnerComponent {}
